var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{attrs:{"id":"template"}},[(_vm.certificate)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.sanitize(_vm.certificate.certificate))}}):_vm._e()])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }